<template>
	<div>
		<h6 class="headline pa-2 mb-3 text-center">
			GST Invoice Verification
		</h6>
		<v-card
			class="white--text pa-2 d-flex justify-space-between align-center body-2 full-width text-center"
			ripple
			:color="themeInputColor"
		>
			<div style="width: 50%">Name/UserId</div>
			<div style="width: 50%">City/State</div>
		</v-card>
		<v-card
			v-if="!pendingInvoices.length"
			class="text-center pa-4 body-2"
			:loading="true"
		>
			<div>No pending invoices for verification</div>
		</v-card>
		<v-card
			v-for="{
				retailerName = '-',
				city = '-',
				state = '-',
				invoiceId,
				dstrId,
				month,
				year
			} in pendingInvoices"
			:key="invoiceId"
			class="pa-2"
		>
			<div class="d-flex justify-space-between align-center full-width">
				<div style="width: 50%">
					<div class="title">{{ retailerName }}</div>
					<div class="caption">{{ dstrId }}</div>
				</div>
				<div class="text-center" style="width: 50%">
					<div class="body-2">{{ city }}</div>
					<div>{{ state }}</div>
					<div class="body-2">
						{{ MONTHS[month].substr(0, 3) }}-{{
							String(year).substr(2, 2)
						}}
					</div>
				</div>
			</div>
		</v-card>
	</div>
</template>

<script>
import { GET_PENDING_INVOICES } from "../../store/action-types";
import { THEME_INPUT_COLOUR, MONTHS } from "../constants";

export default {
	data() {
		return {
			pendingInvoices: [],
			themeInputColor: THEME_INPUT_COLOUR,
			MONTHS
		};
	},
	mounted() {
		this.fetchPendingInvoices();
	},
	methods: {
		fetchPendingInvoices() {
			this.$store
				.dispatch(GET_PENDING_INVOICES.dispatch, {
					type: "finance",
					status: "pending"
				})
				.catch(() => {})
				.then(data => {
					this.pendingInvoices = data || [];
				});
		}
	}
};
</script>
<style scoped>
.rounded-card {
	border-radius: 8px;
}
.float-right {
	position: absolute;
	top: 2px;
	right: 2px;
}
</style>
